<script setup lang="ts">
import eruda from 'eruda'
import VConsole from 'vconsole'
import DisableDevtool from 'disable-devtool'
import hotkeys from 'hotkeys-js'
import eventBus from './utils/eventBus'
import Provider from './ui-provider/index.vue'
import useSettingsStore from '@/store/modules/settings'
import api from '@/api/modules/app'
import useUserStore from '@/store/modules/user'

const userStore = useUserStore()
const loadPermissions = ref(false)
getMyDashboardAccount()
function getMyDashboardAccount() {
  if (userStore && userStore.token) {
    api.getMyDashboardAccount().then((res) => {
      const permissions = res.data
      const auth = ref({})
      const groups = permissions.groups
      for (let i = 0; i < groups.length; i++) {
        const item = groups[i]
        if (item.enable) {
          const itemAuth = item.auth
          itemAuth.forEach((power: string) => {
            auth.value[power] = '1'
          })

          if (Object.keys(auth.value).length === 4) {
            break
          }
        }
      }

      // permissions.role = 'guest'

      userStore.setPowerSore({
        role: permissions.role,
        auth: auth.value,
      })

      loadPermissions.value = permissions.role !== 'guest'

      // if (permissions.role !== 'guest' && Object.keys(auth.value).length > 0) {
      //   const children = ref<any[]>([])
      //   if (auth.value['auth_manage_group'] === '1') {
      //     children.value.push(ManageGroup)
      //   }
      //   if (auth.value['auth_manage_user_account'] === '1') {
      //     children.value.push(ManageUserAccount)
      //   }
      //   if (auth.value['auth_manage_exchange_account'] === '1') {
      //     children.value.push(ManageExchangeAccount)
      //   }
      //   children.value.push(ManageStrategies)
      //   asyncRoutes.push({
      //     meta: {
      //       title: '权限管理',
      //       icon: 'i-mage:box-3d',
      //     },
      //     children: children.value,
      //   })
      // }
      // const routeStore = useRouteStore()
      // routeStore.generateRoutesAtFront(asyncRoutes)
    }).catch(() => {
      loadPermissions.value = true
    })
  }
  else {
    loadPermissions.value = true
  }
}

const route = useRoute()

const settingsStore = useSettingsStore()
const { auth } = useAuth()

const isAuth = computed(() => {
  return route.matched.every((item) => {
    return auth(item.meta.auth ?? '')
  })
})

// 侧边栏主导航当前实际宽度
const mainSidebarActualWidth = computed(() => {
  let actualWidth = Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue('--g-main-sidebar-width'))
  if (settingsStore.settings.menu.mode === 'single' || (settingsStore.settings.menu.mode === 'head' && settingsStore.mode !== 'mobile')) {
    actualWidth = 0
  }
  return `${actualWidth}px`
})

// 侧边栏次导航当前实际宽度
const subSidebarActualWidth = computed(() => {
  let actualWidth = Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue('--g-sub-sidebar-width'))
  if (settingsStore.settings.menu.subMenuCollapse && settingsStore.mode !== 'mobile') {
    actualWidth = Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue('--g-sub-sidebar-collapse-width'))
  }
  return `${actualWidth}px`
})

// 设置网页 title
watch([
  () => settingsStore.settings.app.enableDynamicTitle,
  () => settingsStore.title,
], () => {
  if (settingsStore.settings.app.enableDynamicTitle && settingsStore.title) {
    const title = typeof settingsStore.title === 'function' ? settingsStore.title() : settingsStore.title
    document.title = `${title} - ${import.meta.env.VITE_APP_TITLE}`
  }
  else {
    document.title = import.meta.env.VITE_APP_TITLE
  }
}, {
  immediate: true,
  deep: true,
})

onMounted(() => {
  settingsStore.setMode(document.documentElement.clientWidth)
  window.addEventListener('resize', () => {
    settingsStore.setMode(document.documentElement.clientWidth)
  })
  hotkeys('alt+i', () => {
    eventBus.emit('global-system-info-toggle')
  })
})

import.meta.env.VITE_APP_DEBUG_TOOL === 'eruda' && eruda.init()
import.meta.env.VITE_APP_DEBUG_TOOL === 'vconsole' && new VConsole()
import.meta.env.VITE_APP_DISABLE_DEVTOOL === 'true' && DisableDevtool()
</script>

<template>
  <div v-show="loadPermissions">
    <Provider>
      <RouterView v-slot="{ Component }" :style="{ '--g-main-sidebar-actual-width': mainSidebarActualWidth, '--g-sub-sidebar-actual-width': subSidebarActualWidth }">
        <component :is="Component" v-if="isAuth" />
        <NotAllowed v-else />
      </RouterView>
      <SystemInfo />
    </Provider>
  </div>
</template>
